import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";

import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";

import FormControl from "@mui/material/FormControl";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InfoIcon from "@mui/icons-material/Info";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import SelectQuestionDialog from "./selectQuestionDialog.js";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");
const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "185px, -20px, 20px, -180px", //"120px, -20px, 20px, -5px", //-75px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    min-width: 340px;
    background: #fff;
    color: #000;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    display: flex;
    padding: 8px 5px 8px 5px;
    flex-direction: column;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "250px",
    padding: 0,
    color: "#fff",
    height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "normal",
      textAlign: "center",
    },

    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"  EFFFCA
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
      display: "flex",
      alignItems: "center",
      minHeight: 50,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "#E3F2FD !important",
    },
    "& .MuiDataGrid-cell[data-field='question']": {
      backgroundColor: "#EFFFCA",
    },
    [`& .${gridClasses.cell}.colSpan[data-field='applicantAnswer2']`]: {
      justifyContent: "center",
    },
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "&.MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
  },
  textFieldStyle: {
    minwidth: 80,
    width: 80,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      height: 40,
      borderRadius: 10,
      fontSize: 16,
      display: "flex",
      justifyContent: "center",
    },
    "& .MuiOutlinedInput-input": {
      textAlign: "center",
      paddingLeft: 20,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  dataGridFooterStyle: {
    height: 56,
    marginBottom: 0,
    display: "flex",
    alignItems: "center",
    backgroundColor: "#99D4FF",
  },
  dataGridFooterTextStyle: {
    color: "#0D47A1",
    fontSize: 18,
    fontWeight: 700,
    textAlign: "center",
    //marginLeft: 22,
  },
}));
const staticData = [
  {
    id: 1,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "Italy", //Applicant answer
        answerList: [], // available answer in form
        scoreList: [], // score for answer in form
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
        ],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5, 5],
        awardedScore: [5, 5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 20,
  },
  {
    id: 2,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "England",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
  {
    id: 3,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "USA",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
  {
    id: 4,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "USA",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
  {
    id: 5,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "South Africa",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
  {
    id: 6,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "Germany",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
];
function ApplicantsOneOnOne({ applicants, applySelectedQues, initQuesList }) {
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [applicantsDetail, setApplicantsDetail] = useState([]); // all applicants detail rows
  const [detailRows, setDetailRows] = useState([]); // will be updated by selecting the questions
  const [openSelQuesDlg, setOpenSelQuesDlg] = useState(false);
  const [quesList, setQuesList] = useState(initQuesList);
  const [applicantName1] = useState([applicants[0].applicantName]);
  const [applicantName2] = useState([applicants[1].applicantName]);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  const [errorMsg, setErrorMsg] = useState({
    noOfSeats: "",
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  useEffect(() => {
    const foundRow1 = staticData.find((item) => item.id === applicants[0].id);
    const foundRow2 = staticData.find((item) => item.id === applicants[1].id);
    if (!foundRow1 || !foundRow2) return;
    let rows = [];
    //first row with col span
    rows.push({
      index: 0,
      answer1: "",
      question: "",
      answerList: [],
      scoreList: [],
      type1: "",
      assignedScore1: "",
      awardedScore1: "",
      answer2: "",
      type2: "",
      assignedScore2: "",
      awardedScore2: "",
    });
    for (var i = 0; i < foundRow1.applicantsDetailRows.length; i++) {
      let row = [];
      row["index"] = i + 1;
      row["answer1"] = foundRow1.applicantsDetailRows[i].answer;
      row["question"] = foundRow1.applicantsDetailRows[i].question;
      row["answerList"] = foundRow1.applicantsDetailRows[i].answerList;
      row["scoreList"] = foundRow1.applicantsDetailRows[i].scoreList;
      row["type1"] = foundRow1.applicantsDetailRows[i].type;
      row["assignedScore1"] = foundRow1.applicantsDetailRows[i].assignedScore;
      row["awardedScore1"] = foundRow1.applicantsDetailRows[i].awardedScore;
      row["answer2"] = foundRow2.applicantsDetailRows[i].answer;
      row["type2"] = foundRow2.applicantsDetailRows[i].type;
      row["assignedScore2"] = foundRow2.applicantsDetailRows[i].assignedScore;
      row["awardedScore2"] = foundRow2.applicantsDetailRows[i].awardedScore;
      rows.push({
        index: row.index,
        answer1: row.answer1,
        question: row.question,
        answerList: row.answerList,
        scoreList: row.scoreList,
        type1: row.type1,
        assignedScore1: row.assignedScore1,
        awardedScore1: row.awardedScore1,
        answer2: row.answer2,
        type2: row.type2,
        assignedScore2: row.assignedScore2,
        awardedScore2: row.awardedScore2,
      });
    }
    if (quesList.length === 0) {
      // set Question list for first time
      let quesList = [];
      foundRow1.applicantsDetailRows.map((item) => {
        quesList.push(item.question);
      });
      setQuesList(quesList);
    }
    setApplicantsDetail(rows);
    setDetailRows(rows);
  }, [applicants]);

  useEffect(() => {
    let newList = [];
    if (applicantsDetail.length === 0) return;
    applicantsDetail.map((row, index) => {
      if (index === 0) newList.push(row); // to show applicant name
      const quesIdx = quesList.findIndex(
        (item) => item.id === row.question.id && item.checked
      );
      if (quesIdx !== -1) newList.push(row);
    });
    setDetailRows(newList);
  }, [quesList, applicantsDetail]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const classes = useStyles();

  const columns = [
    {
      field: "assignedScore1",
      headerName: "Assigned Score",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      height: 50,
      //    flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      colSpan: (value, row) => {
        if (row.index === 0) {
          return 3;
        }
        return undefined;
      },
      renderCell: (rows) => {
        if (rows.row.index === 0) {
          return (
            <>
              <Typography
                style={{ paddingRight: 5, paddingBottom: 2 }}
                variant="h2"
              >
                Applicant:
              </Typography>
              <Typography variant="h3">{applicantName1}</Typography>
            </>
          );
        }
        if (rows.row.assignedScore1 == "N/A")
          return <div>{rows.row.assignedScore1}</div>;
        else {
          return (
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.assignedScore1.map((as, index) => (
                <Box
                  pt={0.5}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: 40,
                  }}
                >
                  {as}
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
    {
      field: "awardedScore1",
      headerClassName: "super-app-theme--header",
      headerName: "Awarded Score",
      minWidth: 100,
      height: 50,
      //  flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.awardedScore1 == "N/A")
          return <div>{rows.row.awardedScore1}</div>;
        else {
          return (
            <Box
              pb={0.5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.awardedScore1.map((aw, index) => (
                <Box pt={0.5}>
                  <TextField
                    className={classes.textFieldStyle}
                    name="awardedScore1"
                    variant="outlined"
                    defaultValue={aw}
                    type="number"
                    InputProps={{
                      inputProps: { min: 0, pattern: "[0-9]*" },
                    }}
                    onKeyPress={(e) => {
                      if (e?.key === "-" || e?.key === "+") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      updateAssignedScore(
                        e.target.value,
                        rows.row.index,
                        index,
                        "awardedScore1"
                      )
                    }
                  />
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
    {
      field: "applicantAnswer1",
      headerName: "Applicant Answer",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.type1 === "text" || rows.row.type1 === "textarea") {
          return <Typography variant="h3">{rows.row.answer1}</Typography>;
        } else if (rows.row.type1 === "radio_button") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12} style={{ paddingLeft: 15 }}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {rows.row.answer1.map((item, i) => (
                      <FormControlLabel
                        value={item}
                        onClick={(e) => e.preventDefault()}
                        style={{ cursor: "default" }}
                        control={
                          <Radio
                            disableRipple
                            onClick={(e) => e.preventDefault()}
                            style={{ cursor: "default", paddingLeft: 0 }}
                            checked={true}
                            tabIndex={"-1"}
                          />
                        }
                        label={item}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          );
        } else if (rows.row.type1 === "checkbox_multiple") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12}>
                {rows.row.answer1.map((item, i) => (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={true}
                        style={{ color: "#0D47A1", paddingLeft: 0 }}
                        tabIndex={"-1"}
                      />
                      <Typography variant="h3">{item}</Typography>
                    </Box>
                  </Box>
                ))}
              </Grid>
            </Grid>
          );
        }
      },
    },
    {
      field: "question",
      headerClassName: "super-app-theme--header",
      headerName: "Question",
      minWidth: 100,
      height: 50,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        let title = (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 10,
              }}
            >
              <Grid item xs={9}>
                <Typography variant="h2">Answer</Typography>
              </Grid>

              <Grid item xs={3} style={{ textAlign: "center" }}>
                <Typography style={{ paddingTop: 3 }} variant="h2">
                  Assigned Score
                </Typography>
              </Grid>
            </Grid>
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type1 === "checkbox_multiple" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={false}
                        style={{ padding: 5 }}
                      />

                      <Typography variant="h3">{item}</Typography>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "center" }}>
                      <Typography style={{ paddingTop: 3 }} variant="h2">
                        {rows.row.scoreList[index]}
                      </Typography>
                    </Grid>
                  </Grid>
                )
            )}
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type1 === "radio_button" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="female"
                          name="radio-buttons-group"
                          style={{ paddingLeft: 10 }}
                        >
                          <FormControlLabel
                            value={item}
                            control={
                              <Radio checked={false} style={{ padding: 5 }} />
                            }
                            label={
                              <Typography
                                variant="h3"
                                style={{ color: "black" }}
                              >
                                {item}
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "center" }}>
                      <Typography style={{ paddingTop: 3 }} variant="h2">
                        {rows.row.scoreList[index]}
                      </Typography>
                    </Grid>
                  </Grid>
                )
            )}
          </Box>
        );
        if (
          rows.row.type2 === "radio_button" ||
          rows.row.type2 === "checkbox_multiple"
        )
          return (
            <Box
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <StyledTooltip title={title}>
                <Box pr={1} pt={0.5} style={{ textAlign: "left" }}>
                  <InfoIcon
                    height={24}
                    color="action"
                    style={{ cursor: "pointer" }}
                  />
                </Box>
              </StyledTooltip>
              <Typography variant="h2">{rows.row.question.value}</Typography>
            </Box>
          );
        else
          return (
            <Typography variant="h2">{rows.row.question.value}</Typography>
          );
      },
    },
    {
      field: "applicantAnswer2",
      headerName: "Applicant Answer",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      colSpan: (value, row) => {
        if (row.index === 0) return 3;
        return undefined;
      },
      renderCell: (rows) => {
        if (rows.row.index === 0) {
          return (
            <>
              <Typography
                style={{ paddingRight: 5, paddingBottom: 2 }}
                variant="h2"
              >
                Applicant:
              </Typography>
              <Typography variant="h3">{applicantName2}</Typography>
            </>
          );
        }
        if (rows.row.type2 === "text" || rows.row.type2 === "textarea") {
          return <Typography variant="h3">{rows.row.answer2}</Typography>;
        } else if (rows.row.type2 === "radio_button") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12} style={{ paddingLeft: 15 }}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {rows.row.answer2.map((item, i) => (
                      <FormControlLabel
                        value={item}
                        onClick={(e) => e.preventDefault()}
                        style={{ cursor: "default" }}
                        control={
                          <Radio
                            disableRipple
                            onClick={(e) => e.preventDefault()}
                            style={{ cursor: "default", paddingLeft: 0 }}
                            checked={true}
                            tabIndex={"-1"}
                          />
                        }
                        label={
                          <Typography variant="h3" style={{ color: "#1d1f21" }}>
                            {item}
                          </Typography>
                        }
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          );
        } else if (rows.row.type2 === "checkbox_multiple") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12}>
                {rows.row.answer2.map((item, i) => (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={true}
                        style={{ color: "#0D47A1", paddingLeft: 0 }}
                        tabIndex={"-1"}
                      />
                      <Typography variant="h3">{item}</Typography>
                    </Box>
                  </Box>
                ))}
              </Grid>
            </Grid>
          );
        }
      },
    },
    {
      field: "awardedScore2",
      headerClassName: "super-app-theme--header",
      headerName: "Awarded Score",
      minWidth: 100,
      height: 50,
      //  flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.awardedScore2 == "N/A")
          return <div>{rows.row.awardedScore2}</div>;
        else {
          return (
            <Box
              pb={0.5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.awardedScore2.map((aw, index) => (
                <Box pt={0.5}>
                  <TextField
                    className={classes.textFieldStyle}
                    name="awardedScore2"
                    variant="outlined"
                    defaultValue={aw}
                    type="number"
                    InputProps={{
                      inputProps: { min: 0, pattern: "[0-9]*" },
                    }}
                    onKeyPress={(e) => {
                      if (e?.key === "-" || e?.key === "+") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      updateAssignedScore(
                        e.target.value,
                        rows.row.index,
                        index,
                        "awardedScore2"
                      )
                    }
                  />
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
    {
      field: "assignedScore2",
      headerName: "Assigned Score",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      height: 50,
      //  flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.assignedScore2 == "N/A")
          return <div>{rows.row.assignedScore2}</div>;
        else {
          return (
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.assignedScore2.map((as, index) => (
                <Box
                  pt={0.5}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: 40,
                  }}
                >
                  {as}
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
  ];
  const updateAssignedScore = (value, index, scoreIdx, applicant) => {
    const foundAppDetailRow = applicantsDetail.find(
      (appDetail) => appDetail.index === index
    );
    if (applicant === "awardedScore1") {
      foundAppDetailRow.awardedScore1[scoreIdx] = parseInt(value);
      const foundDetailRow = detailRows.find((row) => row.index === index);
      foundDetailRow.awardedScore1[scoreIdx] = parseInt(value);
    } else if (applicant === "awardedScore2") {
      foundAppDetailRow.awardedScore2[scoreIdx] = parseInt(value);
      const foundDetailRow = detailRows.find((row) => row.index === index);
      foundDetailRow.awardedScore2[scoreIdx] = parseInt(value);
    }
  };
  const customFooter = () => {
    let calAssignedScore1 = 0;
    let calAwardedScore1 = 0;
    let calAssignedScore2 = 0;
    let calAwardedScore2 = 0;
    applicantsDetail.map((item, index) => {
      if (index === 0) return;
      item.assignedScore1 !== "N/A" &&
        item.assignedScore1.map((ass) => {
          if (parseInt(ass)) calAssignedScore1 += ass;
        });
      item.awardedScore1 !== "N/A" &&
        item.awardedScore1.map((aw) => {
          if (parseInt(aw)) calAwardedScore1 += aw;
        });
      item.assignedScore2 !== "N/A" &&
        item.assignedScore2.map((ass) => {
          if (parseInt(ass)) calAssignedScore2 += ass;
        });
      item.awardedScore2 !== "N/A" &&
        item.awardedScore2.map((aw) => {
          if (parseInt(aw)) calAwardedScore2 += aw;
        });
    });
    return (
      <Grid container className={classes.dataGridFooterStyle}>
        <Grid item xs={1}>
          <Typography className={classes.dataGridFooterTextStyle}
          style={{ textAlign: "left", paddingLeft: 40 }}>
            {calAssignedScore1}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography
            style={{ textAlign: "left", paddingLeft: 25 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAwardedScore1}
          </Typography>
        </Grid>
        <Grid item xs={8} style={{ textAlign: "center" }}>
          <Typography className={classes.dataGridFooterTextStyle}>
            Total Score
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography
            style={{ textAlign: "left", paddingLeft: 57 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAwardedScore2}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography
            style={{ textAlign: "left", paddingLeft: 50 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAssignedScore2}
          </Typography>
        </Grid>
      </Grid>
    );
  };
  if (loadContent)
    return (
      <>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              onClick={() => setOpenSelQuesDlg(true)}
            >
              Select Questions
            </Button>
          </Grid>
        </Grid>
        <Box style={{ marginTop: 20 }}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={detailRows}
            showCellRightBorder={true}
            getRowId={(row) => row.index}
            autoHeight={true}
            getRowClassName={(rows) => {
              if (rows.row.index % 2 === 0) return "even";
              else return "odd";
            }}
            getCellClassName={(rows) => {
              if (rows.row.index === 0) return "colSpan";
            }}
            getRowHeight={() => "auto"}
            //experimentalFeatures={{ newEditingApi: true }}
            hideFooterSelectedRowCount
            slots={{
              footer: customFooter,
            }}
          />
        </Box>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Grid
            item
            xs={6}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              //  style={{width:180/*, marginLeft:15*/}}
            >
              Save Awarded Score
            </Button>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              //    style={{width:180/*, marginRight:15*/}}
            >
              Save Awarded Score
            </Button>
          </Grid>
        </Grid>
        {openSelQuesDlg && (
          <SelectQuestionDialog
            quesList={quesList}
            applySelections={(selQuesLst) => {
              setOpenSelQuesDlg(false);
              setQuesList(selQuesLst);
              applySelectedQues(selQuesLst);
            }}
            closeDialog={() => setOpenSelQuesDlg(false)}
          />
        )}
      </>
    );
  else return;
}

export default ApplicantsOneOnOne;
